<div class="mx-auto" style="max-width: 38.75rem">
  <div class="mb-4">
    <img [attr.src]="staticImagePath()" alt="" class="d-block img-fluid mx-auto" style="min-width: 232px; max-width: min(320px, 100%)" />
  </div>
  <div [ngClass]="alignmentClass()">
    <mwe-headline [text]="headlineText()" cssClass="h3 mb-3" [headlineNodeType]="headlineNodeType()" />
    <mwe-headline [text]="headline2Text()" cssClass="h5" [headlineNodeType]="headline2NodeType()" />
    @if (messageKeys()) {
      @for (key of messageKeys(); track key) {
        <p class="mb-4" [innerHTML]="key | translate: translateValues() | safeHtml"></p>
      }
    }
  </div>
  <div class="row g-3" [ngClass]="rowAlignmentClass()">
    @if (ctaLabel()) {
      <div class="col-auto">
        <mwe-button
          [labelKey]="ctaLabel()"
          category="primary"
          (clicked)="onCtaClick.emit()"
          [showSpinner]="ctaShowSpinner()"
          [disabled]="ctaShowSpinner()"
        />
      </div>
    }
    @if (cta2Label()) {
      <div class="col-auto">
        <mwe-button
          [labelKey]="cta2Label()"
          category="secondary"
          (clicked)="onCta2Click.emit()"
          [showSpinner]="cta2ShowSpinner()"
          [disabled]="cta2ShowSpinner()"
        />
      </div>
    }
  </div>
</div>
